var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['common-icon-container', !_setup.isPC && 'common-icon-container-mobile'],style:({
    padding: _setup.iconHotAreaSize,
  }),on:{"click":_setup.handleImgClick}},[(_setup.isApp)?_c('image',{staticClass:"common-icon",style:({ width: _setup.iconWidth, height: _setup.iconHeight }),attrs:{"src":_setup.props.file}}):_c('img',{staticClass:"common-icon",style:({ width: _setup.iconWidth, height: _setup.iconHeight }),attrs:{"src":_setup.props.file}})])
}
var staticRenderFns = []

export { render, staticRenderFns }